/* eslint-disable prefer-destructuring */
/* global G */
import ui from 'lib/hook/ui/update'
import create from 'app/_shared/hook/appbar/create'
import validate from 'lib/hook/model/validate'
import read from 'lib/hook/model/read'
import confirm from 'lib/hook/router/confirm'
import submit from 'lib/hook/model/submit'
import clear from 'app/_shared/hook/model/clear'
import reset from 'app/_shared/hook/component/reset'
import check from 'app/_shared/hook/check'
import { setKey } from 'lib/util'
import back from 'app/_shared/hook/redirect/back'
import modelReset from 'lib/hook/model/reset'
import toggleEmailValidator from 'app/_shared/hook/model/toggleEmailValidator'
import recall from 'app/_shared/hook/component/recall'
import cacheTitle from 'app/_shared/hook/model/cacheTitle'
import updateCache from 'app/_shared/hook/model/updateCache'
import onlineCheck from 'app/_shared/hook/onlineCheck'
import platform from 'app/_shared/hook/platform'
import multiCreate from 'app/_shared/hook/appbar/multiCreate'
import search from 'app/_shared/hook/appbar/search'
import quickActions from 'app/_shared/hook/appbar/quickActions'
import { confirmation } from 'lib/hook/transaction'
import action, { currentAction } from 'lib/hook/module/action'
import recent from 'app/recent/hook/recent'
import appBarBack from 'app/_shared/hook/appbar/back'
import stepper from 'app/_shared/hook/stepper'
import mapAttribute from 'app/_shared/hook/model/mapAttribute'
import bulk from 'lib/hook/model/bulk'
import clean from 'app/_shared/hook/action/clean'
import backOrRedirect from 'app/_shared/hook/redirect/backOrRedirect'

const _searchAndCreateHooks = {
  before: [
    platform({
      web: [create, search],
      mobile: [multiCreate],
    }),
    recall,
  ],
  after: [
    ui,
  ],
}

const _newHooks = {
  before: [
    onlineCheck(),
    modelReset,
    reset,
  ],
  after: [
    ui,
    confirm,
  ],
}

const _createHooks = {
  before: [
    onlineCheck(),
    // Clears the module error, so that we can still use redirect to navigate the drawer actions.
    // Should be replaced by using force redirect
    obj => async (...args) => {
      setKey(null, G.ERROR, obj[G.STATE])
      return args
    },
    platform({
      mobile: [
        appBarBack,
        quickActions,
      ],
    }),
  ],
  after: [
    stepper,
    ui,
    confirm,
  ],
}

const _listHooks = {
  before: [
    onlineCheck(),
    platform({
      mobile: [multiCreate],
    }),
  ],
  after: [
    recall,
    ui,
  ],
}

const _editHooks = {
  before: [
    onlineCheck(),
    platform({
      mobile: [quickActions],
    }),
    clear,
    reset,
    read,
  ],
  after: [
    ui,
    confirm,
  ],
}

const _submitFavoriteHooks = {
  before: [],
  after: [
    ui,
    check,
    confirmation('favorite', 'success'),
    action('successFavorite'),
  ],
}

const _successFavoriteHooks = {
  before: [],
  after: [
    currentAction,
  ],
}

// TODO: Check why we need the reset and inline count hook and maybe refactor
const _detailHooks = {
  before: [
    clear,
    // What do we need this for? It breaks favorite functionality
    // platform({
    //   web: reset,
    // }),
    read,
    obj => (...args) => {
      const { count } = args?.[0] || {}
      // Setting the count (which contains the user) we got from the FTS so that we can use it
      count && setKey(count, 'count', obj[G.MODEL][G.CACHE].value)

      return args
    },
    cacheTitle('firstName', 'lastName'),
    recall,
    recent,
    platform({
      mobile: [quickActions, multiCreate],
    }),
  ],
  after: [
    ui,
  ],
}

const _submitHooks = {
  before: [
    toggleEmailValidator(),
    validate,
  ],
  after: [
    ui,
    check,
    submit,
    updateCache,
    obj => (...args) => {
      setKey(obj[G.ADAPTER][G.ROUTER].currentRoute(), G.PREV, obj[G.STATE])
      return args
    },
    back,
  ],
}

const _bulkHooks = {
  before: [
    validate,
  ],
  after: [
    ui,
    bulk,
    clean,
    backOrRedirect,
  ],
}


const _organisationHooks = {
  before: [
    mapAttribute('organisation'),
  ],
  after: [
    ui,
    confirm,
  ],
}

const hooks = {
  [G.ACTIONS]: {
    index: _searchAndCreateHooks,
    newColleague: _newHooks,
    newContact: _newHooks,
    create: _createHooks,
    edit: _editHooks,
    detail: _detailHooks,
    bulk: _bulkHooks,
    submit: _submitHooks,
    organisation: _organisationHooks,
    requests: _listHooks,

    submitFavorite: _submitFavoriteHooks,
    successFavorite: _successFavoriteHooks,
  },
}

export default hooks
